<rt-icon [name]="cardType | rtCreditCardVendorIcon: 'credit-card'"></rt-icon>
&nbsp;••••&nbsp;••••&nbsp;••••&nbsp;{{ cardLast4Digits }}
<rt-divider variant="dot"></rt-divider>
{{
  'app.pricing.billing_page.credit_card_expires'
    | translate: { date: cardExpirationDate | amDateFormat: 'MM / YYYY' }
}}
